module.exports = __webpack_public_path__ + "img/WORKING.38e05261.png";